import React from 'react';
import { Text } from '@chakra-ui/react';

import { CommonColors } from '../../theme/theme';

type Props = {
  children: React.ReactNode;
};

export const ErrorMessage = (props: Props) => {
  const { children } = props;
  return (
    <Text color={CommonColors.errorMessages} fontSize={'sm'}>
      {children}
    </Text>
  );
};
